import { types } from '../actions/types';

export default (state = {}, action) => {
    switch (action.type) {
        case types.RECEIVED_CALENDAR:
            return {
                ...state, week: action.payload
            }
            break;
        case types.RECEIVED_NEXT_CALENDAR:
            return {
                ...state, nextWeek: action.payload
            }
            break;
        case types.RECEIVED_LAST_CALENDAR:
            return {
                ...state, lastWeek: action.payload
            }
            break;
        case types.RECEIVED_CALENDAR_DAY:
            return {
                ...state, calendar: action.payload
            }
            break;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/calendar-reducer.js